import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { ITestConfig } from "../../api/models/TestConfig"
import { API_URL, QUERY_KEYS } from "../constants"

export const useGetTestConfigs = (token: string, orgId?: string) =>
  useQuery<ITestConfig[], Error>({
    queryKey: QUERY_KEYS.testConfigs(orgId),
    queryFn: async () => {
      const url = orgId
        ? `${API_URL}/organizations/${orgId}/test-configs/`
        : `${API_URL}/private/test-configs/`
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })

      if (!res.ok) {
        const parsed = await res.json()
        throw new Error(parsed.error ?? parsed.message ?? parsed ?? "Internal Server Error")
      }

      const json = await res.json()
      if (json.error) {
        throw new Error(json.error)
      }

      return json
    },
  })

export const usePutTestConfig = (token: string, orgId?: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (testConfig: ITestConfig) => {
      const res = await fetch(
        orgId
          ? `${API_URL}/organizations/${orgId}/test-configs/${testConfig._id}`
          : `${API_URL}/private/test-configs/${testConfig._id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(testConfig),
        },
      )
      return await res.json()
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.testConfigs(orgId) })
    },
  })
}
